import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

// This file needs to import from react-router since it's the abstraction
/* eslint-disable no-restricted-imports */
import { Link as ReactRouterLink } from 'react-router-dom';

export function Link({
  to,
  id,
  children,
  target,
  className,
  rel,
  replace,
  style,
  'data-testid': dataTestId,
}: PropsWithChildren<{
  to: string;
  id?: string;
  target?: string;
  className?: string;
  rel?: string;
  replace?: boolean;
  style?: React.CSSProperties;
  'data-testid'?: string;
}>) {
  // to handle security issues with target="_blank"
  const _rel = target === '_blank' ? clsx('noopener noreferrer', rel) : rel;

  return (
    <ReactRouterLink
      to={to}
      className={clsx('wk-link', className)}
      target={target}
      rel={_rel}
      style={style}
      data-testid={dataTestId}
      replace={replace}
      id={id}
    >
      {children}
    </ReactRouterLink>
  );
}
